import FormGroupElement from "./FormGroupElement";

class DateTime extends FormGroupElement {

    render() {
        let className: string = "form-group" + (this.props?.pullRight ? " pull-right" : "");
        return (
            <div className={className}>
                {this.props?.skipLabel !== true && this.createLabel()}<input {...this.prepareProps()}/>{this.createHelp()}
            </div>
        );
    }

    protected prepareProps(): {} | any {
        let props = super.prepareProps();
        if (!props?.type) {
            props.type = "datetime-local";
        }

        props?.skipLabel && delete props.skipLabel;
        props?.pullRight && delete props.pullRight;

        return props;
    }
}

export default DateTime;
